import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import styles from './Navigation.module.css';

import { useGetUserBasketQuery } from '../../store/api/basket.api';
import { useDbUserId } from '../../hooks/useDbUserId';

import homeIcon from '../../assets/home-icon.svg';
import catalogIcon from '../../assets/catalog-icon.svg';
import basketIcon from '../../assets/basket-icon.svg';
import wishlistIcon from '../../assets/wishlist-icon.svg';
import redCircleIcon from '../../assets/red_circle-icon.svg';
import magnifierIcon from '../../assets/magnifier-icon.svg';
import burgerIcon from '../../assets/burger-icon.svg';
import addingIcon from '../../assets/adding-icon.svg';

export const Navigation = ({ activePage, setActivePage, hide }) => {
	const location = useLocation();
	
	const { dbUserId } = useDbUserId();
	const [activeSchema, setActiveSchema] = useState('')

	useEffect(() => {
		setActiveSchema(window.sessionStorage.getItem('schema') || '');
	}, [location])

	useEffect(() => {
		const pathname = location.pathname;

		if (pathname.includes('/home')) {
			setActivePage(1);
		} 
		else if (pathname.includes('/catalog')) setActivePage(2);
		else if (pathname.includes('/basket')) setActivePage(3);
		else if (pathname.includes('/wishlist')) setActivePage(4);
		else if (pathname.includes('/steam/adding')) {
			setActivePage(1);
			setActiveSchema('steam')
		}
		else if (pathname.includes('/steam/cards')) setActivePage(2);
	}, [location.pathname]);	

	
	// 🔍 Вычисляем baseUrl прямо из текущего пути
	const baseUrl = (() => {
		const path = location.pathname.split('/').filter(Boolean);
		return path.length && path[0].includes('keys') ? `/${path[0]}` : '';
	})();

	// Формируем корректный путь
	const formatUrl = (path) => {
		if (!path.startsWith('/')) path = `/${path}`;
		return `${baseUrl}${path}`;
	};

	const { data: basketData } = useGetUserBasketQuery({ userId: dbUserId, schema: activeSchema }, {
		skip: !dbUserId || location.pathname.includes('/xbox'),
	});

	const isSearchPage = location.pathname.includes('search');
	
	if (location.pathname === '/' || activeSchema === 'xbox' || activeSchema === 'fifa') return;

	if (activeSchema === 'steam') {

		return (
			<nav style={hide ? {visibility: 'hidden'} : {}} className={`${styles.main} ${styles.main_steam}`}>

				<div className={styles.icons_blok}>
					<Link
						to={'steam/adding'}
						state={{ schema: 'steam' }}
						className={`${styles.icon_container} ${activePage === 1 && styles.active}`}
					>
						<img src={addingIcon} alt="addingIcon" />
					</Link>

					<Link
						to={'steam/cards'}
						state={{ schema: 'steam' }}
						className={`${styles.icon_container} ${activePage === 2 && styles.active}`}
					>
						<img src={catalogIcon} alt="catalogIcon" />
					</Link>

					<Link
						to={'/basket'}
						state={{ schema: 'steam' }}
						className={`${styles.icon_container} ${activePage === 3 && styles.active}`}
					>
						<div className={styles.basket_block}>
							<img src={basketIcon} alt="basketIcon" />
							{basketData?.items?.length > 0 && (
								<div className={styles.redCircleIcon_block}>
									<span>{basketData.items.length > 9 ? '9' : basketData.items.length}</span>
									<img src={redCircleIcon} alt="redCircleIcon" />
								</div>
							)}
						</div>
					</Link>

				</div>
			</nav>
		);
	}

	return (
		<nav className={styles.main}>
			{!isSearchPage && (
				<div className={styles.search_container}>
					<div className={styles.country_container}>
						<Link to="/">
							<img src={burgerIcon} alt="burgerIcon" />
						</Link>
					</div>
					<div className={styles.search_block}>
						<Link className={styles.search_link} to="/search">
							<div className={styles.search}>
								<span className={styles.placeholder}>Поиск</span>
								<img src={magnifierIcon} alt="magnifierIcon" />
							</div>
						</Link>
					</div>
				</div>
			)}

			<div className={styles.icons_blok}>
				<Link
					to={activeSchema ? `/${activeSchema}/home` : '/home'}
					state={{ schema: activeSchema}}
					className={`${styles.icon_container} ${activePage === 1 && styles.active}`}
				>
					<img src={homeIcon} alt="homeIcon" />
				</Link>

				<Link
					to={'/catalog'}
					state={{ schema: formatUrl('/catalog').split('/')[1]}}
					className={`${styles.icon_container} ${activePage === 2 && styles.active}`}
				>
					<img src={catalogIcon} alt="catalogIcon" />
				</Link>

				<Link
					to={'/basket'}
					state={{ schema: activeSchema}}
					className={`${styles.icon_container} ${activePage === 3 && styles.active}`}
				>
					<div className={styles.basket_block}>
						<img src={basketIcon} alt="basketIcon" />
						{basketData?.items?.length > 0 && (
							<div className={styles.redCircleIcon_block}>
								<span>{basketData.items.length > 9 ? '9' : basketData.items.length}</span>
								<img src={redCircleIcon} alt="redCircleIcon" />
							</div>
						)}
					</div>
				</Link>

				<Link
					to={'/wishlist'}
					className={`${styles.icon_container} ${activePage === 4 && styles.active}`}
				>
					<img src={wishlistIcon} alt="wishlistIcon" />
				</Link>
			</div>
		</nav>
	);
};
